import { useState, useEffect } from 'react';
import API_CIFRA from '../config/Variables_apis';

export const useWeather = (latitude, longitude) => {
  const [temperature, setTemperature] = useState(null);
  const [weatherCode, setWeatherCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!latitude || !longitude) {
      setTemperature(null);
      return;
    }

    const fetchTemperature = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Usar OpenWeatherMap API desde configuración
        const url = API_CIFRA.weather.currentWeather(latitude, longitude);
        
        const response = await fetch(url);
        const data = await response.json();
        
        if (response.ok && data.current) {
          if (data.current.temperature_2m) {
            setTemperature(Math.round(data.current.temperature_2m));
          }
          if (data.current.weather_code) {
            setWeatherCode(data.current.weather_code);
          }
        } else {
          // Si hay error, usar temperatura simulada
          console.warn('Open-Meteo API no disponible, usando temperatura simulada');
          const simulatedTemp = Math.floor(Math.random() * 15) + 15; // 15-30°C
          setTemperature(simulatedTemp);
          setWeatherCode(0); // Código para cielo despejado
        }
      } catch (error) {
        console.warn('No se pudo obtener temperatura real, usando simulada:', error);
        // Temperatura simulada como fallback
        const simulatedTemp = Math.floor(Math.random() * 15) + 15; // 15-30°C
        setTemperature(simulatedTemp);
      } finally {
        setLoading(false);
      }
    };

    fetchTemperature();
  }, [latitude, longitude]);

  return { temperature, weatherCode, loading, error };
};
